export const getDiscount = (item, productData) => {
  if (!productData) {
    return 0;
  }

  const {
    qty,
    product_option: {
      extension_attributes: {quotepro_discounts}
    }
  } = item;
  let discount = null;
  const itemPrice = productData?.itemPrice || item?.price || 0;

  if (productData?.savings) {
    discount = (productData.savings * qty) || 0;
  } else if (productData?.discount_options) {
    const {price, price_type} = quotepro_discounts || {price: null, price_type: ''};

    const selectedDiscountData = productData?.discount_options?.find((option) => Number(option?.price) === Number(price) && option?.price_type === price_type) || null;

    if (selectedDiscountData) {
      discount = selectedDiscountData.price_type === 'fixed'
        ? Math.abs(selectedDiscountData.price * qty).toFixed(2)
        : Math.abs((selectedDiscountData.price * itemPrice / 100) * qty).toFixed(2);
    }
  }

  return discount;
};
